/**
 * Nomenclatura de steps do bot (padrão snake_case em português).
 * LEGACY_STEP_ALIASES mantém compatibilidade com histórico salvo no backend.
 */

export const LEGACY_STEP_ALIASES = {
  "copy-message-1": "copy_inicial",
  "check-resume": "verifica_retomada",
  "resume-conversation": "retomar_conversa",

  "lead-category-start": "carrega_categorias",
  "lead-select-category": "escolha_categoria",
  "lead-basic-name": "pergunta_nome",
  "lead-greetings": "saudacao_nome",
  "lead-credit-guide": "introducao_simulacao",
  "lead-credit-value": "pergunta_valor_credito",
  "lead-credit-value-add": "informa_valor_credito",
  "lead-select-plan": "escolha_tipo_plano",
  "basico-valor-renda": "pergunta_valor_renda",
  "sem-renda-extra": "sem_renda_extra",
  "com-renda-extra": "pergunta_renda_extra",
  "renda-extra-adicinada": "renda_extra_confirmada",
  "lead-message-for-email": "mensagem_email",
  "lead-add-email": "pergunta_email",
  "lead-add-phone": "pergunta_celular",
  "lead-get": "registra_lead",
  "lead-show-plan-message": "mensagem_lista_planos",
  "lead-show-plan-list": "planos_disponiveis",
  "servico-tabela-completa": "tabela_servicos_completa",

  "proposal-plans-list-carousel-get": "carrega_planos",
  "plans-list-select": "selecao_planos",
  "plans-list-carousel-show-message": "mensagem_carrossel_planos",
  "parcela-desconto-mensagem": "mensagem_desconto_parcela",
  "parcela-desconto-valor": "valor_desconto_parcela",
  "proposal-confirm-infos": "confirmacao_informacoes",
  "vamos_fechar": "confirmacao_informacoes",
  "proposal-plan-holder": "titular_plano",
  "proposal-add-name-razao": "nome_completo",
  "proposal-add-cpf-cnpj": "cpf_cnpj",
  "proposal-add-cep": "cep",
  "proposal-thanks-message": "agradecimento_cep",
  "proposal-wait-data-register": "aguarda_registro_dados",
  "proposal-add-date": "nascimento_fundacao",
  "proposal-confirm-data": "revisao_dados_pessoais",
  "proposal-show-data": "exibe_dados_cadastrais",
  "proposal-285-message": "mensagem_resolucao_285",
  "proposal-show-summmary": "confirmacao_dados_cadastrais",
  "proposal-terms": "termos_regulamento",
  "proposal-change-infos": "menu_alterar_dados",
  "proposal-confirm-plan": "confirma_detalhes_plano",
  "select-plan-confirm": "confirma_plano_selecionado",
  "proposal-change-name": "alterar_nome_completo",
  "proposal-wait": "aguarda_proposta",
  "proposal-success": "proposta_criada",
  "proposal-buy-again": "comprar_outra_cota",
  "proposal-change-email": "alterar_email",
  "proposal-change-cpf-cnpj": "alterar_cpf_cnpj",
  "proposal-change-phone": "alterar_celular",
  "proposal-change-date": "alterar_nascimento",
  "proposal-change-cep": "alterar_cep",

  "insurance-validate": "valida_seguro",
  "insurance-initial-message": "apresentacao_seguro",
  "insurance-description-message": "descricao_seguro",
  "insurance-select": "escolha_seguro",
  "insurance-term": "termos_seguro",

  "cupom-initial-message": "pergunta_cupom",
  "cupom-input": "informa_codigo_cupom",
  "cupom-error-message-1": "erro_cupom",
  "cupom-error-message-2": "erro_cupom_opcoes",
  "cupom-try-again": "tentar_cupom_novamente",
  "cupom-apply-success": "cupom_aplicado",
  "cupom-apply-new-value": "novo_valor_com_cupom",
  "cupom-payment-message": "mensagem_pagamento_cupom",
  "cupom-initial-url": "cupom_url_detectado",
  "cupom-apply-url": "aplica_cupom_url",

  "payment-init": "inicio_pagamento",
  "payment-first-parcel": "primeira_parcela",
  "payment-options": "proposta_gerada",
  "alterar-pagamento": "alterar_forma_pagamento",
  "payment-buy-again-value": "pergunta_mesmo_credito",
  "payment-continue": "continuar_pagamento",
  "compra-finalizada": "compra_finalizada",
  "sem-metodos-pagamento": "sem_metodos_pagamento",

  "payment-credit-card-message-secure": "mensagem_seguranca_cartao",
  "payment-credit-card-message-parcel": "escolha_parcelas_cartao",
  "payment-credit-card-message-parcel-value": "valor_parcelas_cartao",
  "payment-credit-card-select": "formulario_cartao",
  "payment-processing": "processando_cartao",
  "payment-success-dream": "sucesso_cartao",
  "payment-credit-card-pending": "cartao_pendente",
  "payment-refused": "cartao_recusado",
  "payment-pending": "pagamento_pendente",
  "payment-success": "pagamento_aprovado",

  "pagamento-pix-registro": "registro_pix",
  "payment-success-conquest": "conquista_iniciada",
  "payment-pix-options": "gerando_pix",
  "payment-pix-qrcode-message": "mensagem_qrcode_pix",
  "payment-pix-qrcode-show": "qrcode_pix",
  "payment-pix-qrcode-scan": "instrucao_scan_qrcode",
  "payment-pix-qrcode-comeback": "retorno_qrcode_pix",
  "payment-pix-copy-paste": "escolha_copia_cola",
  "payment-pix-copy-paste-message": "codigo_pix_copia_cola",
  "payment-pix-copy-paste-show": "exibe_codigo_pix",
  "payment-pix-copy-paste-button": "botao_copiar_pix",
  "payment-pix-copy-paste-confirm": "confirma_pagamento_pix",
  "payment-pix-copy-paste-bank-message": "instrucao_banco_pix",
  "payment-pix-copy-paste-bank-message-select": "seleciona_banco_pix",
  "payment-pix-copy-paste-comeback": "retorno_copia_cola",
  "payment-pix-payment-confirmation": "confirmacao_pagamento_pix",
  "payment-pix-payment-confirmation-failed": "erro_confirmacao_pix",
  "payment-pix-payment-confirmation-bank": "confirma_pagamento_banco_pix",
  "payment-pix-payment-confirmation-bank-again":
    "confirma_pagamento_banco_novamente",
  "payment-email-sended": "email_pix_enviado",
  "payment-important-step-message": "mensagem_importante_pix",
  "payment-for-you-message": "mensagem_para_voce_pix",
  "pagamento-pix-tentar-novamente": "erro_pix_tentar_novamente",

  "pagamento-boleto-registro": "gerando_boleto",
  "payment-congratulations": "parabens_boleto",
  "payment-boleto-options": "opcoes_boleto",
  "payment-boleto-bar-code-message": "codigo_boleto",
  "payment-boleto-bar-code-show": "exibe_codigo_boleto",
  "payment-boleto-bar-code-copy": "copiar_codigo_boleto",
  "payment-open-bank-app": "abrir_app_banco",
  "payment-assembly": "proxima_assembleia",
  "pagamento-boleto-tentar-novamente": "erro_boleto_tentar_novamente",

  "error-no-plans": "erro_sem_planos",
  "error-renda-insuficiente": "erro_renda_insuficiente",
  "error-proposta": "erro_proposta",
  "error-general": "erro_geral",
  "error-connection-start": "erro_conexao_inicio",
  "error-connection-message": "erro_conexao",
  "cep-error": "erro_cep",
  "cep-not-found": "cep_nao_encontrado",
  "cep-try-again": "tentar_cep_novamente",
  "cep-add-street": "informa_logradouro",
  "cep-add-neighborhood": "informa_bairro",

  "pesquisa-inicio": "inicio_pesquisa",
  "pesquisa-midia": "pergunta_conhecer_mycon",
  "pesquisa-nota": "pergunta_avaliacao_mycon",
  "pesquisa-humanos": "pergunta_ajuda_especialista",
  "pesquisa-humanos-pontuacao": "pergunta_nota_especialista",
  "pesquisa-humanos-comentarios": "pergunta_comentario_especialista",
  "pesquisa-agradecimento": "agradecimento_pesquisa",
  "pesquisa-algo-mais": "pergunta_algo_mais",
  "pesquisa-finalizada": "pesquisa_finalizada",
  "pesquisa-ate-mais": "conclusao_fluxo",
};

/** copy-message-2 → copy_intermediaria_2 */
export const resolveLegacyCopyStepName = (stepName) => {
  const match = /^copy-message-(\d+)$/.exec(stepName);
  if (match) {
    const n = match[1];
    return n === "1" ? "copy_inicial" : `copy_intermediaria_${n}`;
  }
  return null;
};

export const resolveStepName = (stepName) => {
  if (typeof stepName !== "string") return stepName;
  const copyResolved = resolveLegacyCopyStepName(stepName);
  if (copyResolved) return copyResolved;
  return LEGACY_STEP_ALIASES[stepName] || stepName;
};

/** copy_intermediaria_2 → copy-message-2 (somente leitura de histórico legado invertido) */
export const toLegacyStepName = (stepName) => {
  const intermediaria = /^copy_intermediaria_(\d+)$/.exec(stepName);
  if (intermediaria) return `copy-message-${intermediaria[1]}`;
  if (stepName === "copy_inicial") return "copy-message-1";
  const entry = Object.entries(LEGACY_STEP_ALIASES).find(([, v]) => v === stepName);
  return entry ? entry[0] : stepName;
};

export const OPENING_BLOCK_STEP = "copy_inicial";
export const OPENING_BLOCK_CTA = "SIMULE AGORA MESMO";
